import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'bv-i18n';

export const TutorialButtonComponent = ({ onClick }) => (
  <div className="inplay-tutorial-button-wrapper">
    <button type="button" onClick={onClick} className="inplay-tutorial-button">{t('javascript.in_play.tutorial.button')}</button>
  </div>
);

TutorialButtonComponent.propTypes = {
  onClick: PropTypes.isRequired,
};

export default TutorialButtonComponent;
